import React from 'react';
import './App.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import AuthLayout from './components/auth/AuthLayout';
import MainLayout from './components/application/MainLayout';

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

function AppContent() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
        <p>Loading Private Split...</p>
      </div>
    );
  }

  return user ? <MainLayout /> : <AuthLayout />;
}

export default App;